import React from 'react';
import { Button } from './ui/button';
import { Video, ExternalLink } from 'lucide-react';

/** Transforme une URL de partage en URL embarquable (YouTube, Vimeo, Loom). */
export const toEmbedUrl = (raw = '') => {
  const url = raw.trim();
  if (!url) return null;

  const yt = url.match(
    /(?:youtube\.com\/(?:watch\?(?:.*&)?v=|embed\/|shorts\/|live\/)|youtu\.be\/)([\w-]{6,})/i
  );
  if (yt) return `https://www.youtube.com/embed/${yt[1]}`;

  const vimeo = url.match(/vimeo\.com\/(?:video\/)?(\d+)/i);
  if (vimeo) return `https://player.vimeo.com/video/${vimeo[1]}`;

  const loom = url.match(/loom\.com\/(?:share|embed)\/([\w-]+)/i);
  if (loom) return `https://www.loom.com/embed/${loom[1]}`;

  return null;
};

const isFileUrl = (url = '') => /\.(mp4|webm|ogg|mov|m4v)(\?|$)/i.test(url.trim());

/** Lecteur vidéo intégré dans la page, avec repli sur un lien externe si la plateforme est inconnue. */
export const VideoEmbed = ({ url = '', className = '', testId = 'video-embed' }) => {
  const clean = (url || '').trim();
  if (!clean) return null;

  const embed = toEmbedUrl(clean);

  if (embed) {
    return (
      <div
        className={`relative w-full overflow-hidden rounded-lg border border-border bg-black/90 ${className}`}
        style={{ aspectRatio: '16 / 9' }}
        data-testid={testId}
      >
        <iframe
          src={embed}
          title="Vidéo de réponse"
          className="absolute inset-0 w-full h-full border-0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
          allowFullScreen
          loading="lazy"
        />
      </div>
    );
  }

  if (isFileUrl(clean)) {
    return (
      <video
        src={clean}
        controls
        preload="metadata"
        className={`w-full rounded-lg border border-border bg-black ${className}`}
        data-testid={`${testId}-file`}
      />
    );
  }

  return (
    <Button
      variant="outline"
      size="sm"
      className={className}
      onClick={() => window.open(clean, '_blank', 'noopener')}
      data-testid={`${testId}-link`}
    >
      <Video className="w-4 h-4 mr-2" />
      Voir la vidéo
      <ExternalLink className="w-3 h-3 ml-2" />
    </Button>
  );
};

export default VideoEmbed;
